import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import type { Node } from 'domains/reporter/RichTextEditor/core';
import {
  emptyRequiredFieldsDialogRecoilState,
  emptyRequiredFieldsDialogStateDefault,
} from '../state';

export const useEmptyRequiredFieldsDialog = (worklistItemSmid: string) => {
  const [state, setState] = useRecoilState(emptyRequiredFieldsDialogRecoilState);

  const isOpenForCurrentCase = state.open === true && state.worklistItemSmid === worklistItemSmid;

  const open = useCallback(
    (emptyRequiredFields: Node[]) => {
      setState({
        emptyRequiredFields,
        open: true,
        worklistItemSmid,
      });
    },
    [setState, worklistItemSmid]
  );

  const close = useCallback(() => {
    setState(emptyRequiredFieldsDialogStateDefault);
  }, [setState]);

  const clearIfOwnedByWorklistItem = useCallback(
    (worklistItemSmidToClear: string) => {
      setState((previous) =>
        previous.worklistItemSmid === worklistItemSmidToClear
          ? emptyRequiredFieldsDialogStateDefault
          : previous
      );
    },
    [setState]
  );

  return {
    state,
    isOpenForCurrentCase,
    open,
    close,
    clearIfOwnedByWorklistItem,
  };
};
